import { render } from "./radio.vue?vue&type=template&id=7affbe9d&scoped=true"
import script from "./radio.vue?vue&type=script&lang=js"
export * from "./radio.vue?vue&type=script&lang=js"

import "./radio.vue?vue&type=style&index=0&id=7affbe9d&scoped=true&lang=css"

import exportComponent from "/Users/apple/Documents/xxiwant/lovestory/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7affbe9d"]])

export default __exports__